export const BASE_COLUMN_WIDTH = 150;
